export enum CustomerTitle {
  Fr = 'Fr.',
  Rev = 'Rev.',
  Msgr = 'Msgr.',
  Bp = 'Bp.',
  Abp = 'Abp.',
  Card = 'Card.',
  Mr = 'Mr.',
  Ms = 'Ms.',
  Mrs = 'Mrs.',
  Sr = 'Sr.',
  Br = 'Br.',
}
